import React from "react";
import { DetailAction as NessieDetailAction, NessieThemeProvider } from "@classdojo/web/nessie";

export const DetailAction = (props) => {
  return (
    <NessieThemeProvider>
      <NessieDetailAction {...props} />
    </NessieThemeProvider>
  );
};
